/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n<div class="breadcrumbs-wrapper"></div>\n\n<div class="file-items-wrapper">\n  ';
 if (data.assetDisplayState == 'list') { ;
__p += '\n    <div class="file-items-list-header">\n      <div class="file-items-list-header-row">\n        <div class="header-item thumbnail-col"></div>\n        <div class="header-item filename-col" data-sort-type="display_filename:asc">\n          Name\n          ';
 if (data.navState.get('sort_by') == 'display_filename:desc') { ;
__p += '\n          <i class="fa fa-caret-down"></i>\n          ';
 } else if (data.navState.get('sort_by') == 'display_filename:asc') { ;
__p += '\n          <i class="fa fa-caret-up"></i>\n          ';
 } ;
__p += '\n        </div>\n        <div class="header-item type-col">Type</div>\n        <div class="header-item uploaded-by-col" data-sort-type="submitter_name:desc">\n          Uploaded By\n          ';
 if (data.navState.get('sort_by') == 'submitter_name:desc') { ;
__p += '\n          <i class="fa fa-caret-down"></i>\n          ';
 } else if (data.navState.get('sort_by') == 'submitter_name:asc') { ;
__p += '\n          <i class="fa fa-caret-up"></i>\n          ';
 } ;
__p += '\n        </div>\n        <div class="header-item last-modified-col" data-sort-type="date_modified:desc">\n          Last Modified\n          ';
 if (data.navState.get('sort_by') == 'date_modified:desc') { ;
__p += '\n          <i class="fa fa-caret-down"></i>\n          ';
 } else if (data.navState.get('sort_by') == 'date_modified:asc') { ;
__p += '\n          <i class="fa fa-caret-up"></i>\n          ';
 } ;
__p += '\n        </div>\n      </div>\n    </div>\n  ';
 } ;
__p += '\n\n  <div class="file-items ' +
__e(data.assetDisplayState) +
'">\n    \n    <div class="files-not-yet-loaded-message">\n      Loading assets...\n    </div>\n\n    <div class="empty-folder-message">\n      ';
 if (data.isPrivateFolder) { ;
__p += '\n        This folder is private. You cannot view its contents.\n      ';
 } else if (data.navState.getIsSearching()) { ;
__p += '\n        No assets match this search.\n      ';
 } else { ;
__p += '\n        This folder is empty.\n      ';
 } ;
__p += '\n    </div>\n\n  </div>\n</div>\n';
return __p
}
